export const characterCounter = (text: string | null, maxChars: number) => ({
  text,
  maxChars,

  get chars() {
    return this.text ? this.text.trim().length : 0
  },
})
